import utilService from '../../services/UtilService';
import sessionConstants from '../../constants/SessionConstants';

const questionUtils = {
    isQuestionRange(number) {
        if (typeof number !== 'string') return false;

        const match = number.match(/^(\d+)\s*[-–]\s*(\d+)$/);
        if (match) {
            const start = parseInt(match[1], 10);
            const end = parseInt(match[2], 10);
            return end > start;
        }

        return false;
    },

    /** * Converts a number to a title-cased word representation for extract labels.
     * * Example: 1 → "One", 2 → "Two", 11 → "Eleven"
     * * @param {number} num - The number to convert (supported range: 1-20)
     * * @returns {string} Title-cased word representation or empty string if num is out of range */
    getExtractNumberWord(num) {
        const n = Number(num);
        const word = utilService.getUpperCaseWordFromNumber(n);

        if (!word) return '';

        return word
            .toLowerCase()
            .split(' ')
            .map(w => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' ');
    },

    getExtractNumber(question, mode) {
        if (mode === sessionConstants.MODE_QUESTION) {
            return 'One';
        }
        return this.getExtractNumberWord(question.questionNumberingInSection);
    },
};

export default questionUtils;
